import BreadcrumbPedidos from "./BreadcrumbPedidos";
import { Form } from "react-bootstrap";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getPedidosEntrega, entregaPedido} from "../../services/PedidosService";
import { getMarcas } from "../../services/MarcasService";
import MaoTable from "../common/MaoTable";
import { getFechaHoy, getFechaInicioMes } from "../../utils/DateUtils";
import { formatNumber } from "../../utils/NumberUtils";
import { Cargando } from "../common/Cargando";
import { FaFilePdf } from "react-icons/fa6";
import { validUuid } from "../../utils/UuidUtils";

const api_pdf = process.env.REACT_APP_HOME_URL+"/pedidos/pdf/";

export default function PedidosEntrega() {
    /*
    Links ->
        https://react-bootstrap.netlify.app/
        https://react-bootstrap.netlify.app/docs/getting-started/introduction/
        https://react-bootstrap.netlify.app/docs/components/breadcrumb
        https://react-bootstrap.netlify.app/docs/forms/overview
        https://react-bootstrap.netlify.app/docs/forms/layout
        https://react-bootstrap.netlify.app/docs/forms/input-group

        https://www.npmjs.com/package/react-icons
     */
    
    const [fechaDesde, setFechaDesde] = useState(getFechaInicioMes());
    const [fechaHasta, setFechaHasta] = useState(getFechaHoy());
    const [estado, setEstado] = useState("");
    const [pedidos, setPedidos] = useState([]);
    const [error, setError] = useState("");
    const [cargando, setCargando] = useState(false);
    const [marcas, setMarcas] = useState([]);
    const [marca, setMarca] = useState();

    useEffect(() => {
        getMarcas()
            .then((resp) => {
                if (resp.error) {
                    setError(resp.message);
                } else {
                    setMarcas(resp.data);
                }
            });
    }, [])

    useEffect(() => {
        buscar();
    }, [])

    async function buscar() {
        let fechaDesdeP = fechaDesde;
        let fechaHastaP = fechaHasta;
        let esatdoP = estado;
        if (fechaDesdeP === undefined || fechaDesdeP==="") {
            setError("");
            setPedidos([]);
            alert("Debe indicar una fecha desde");
        } else {
            setCargando(true);
            let resp = await getPedidosEntrega(fechaDesdeP, fechaHastaP, marca, esatdoP);
            setCargando(false);
            if (resp.error) {
                setError(resp.message);
                setPedidos([]);
            } else {
                setError("");
                setPedidos(resp.data);
            }
        }
    }

    function descargar(uuid) {
        console.log("Intentando descargar PDF con UUID:", uuid);
        if (validUuid(uuid)) {
            window.open(api_pdf+uuid, '_blank'); 
        } else {
            alert("El pdf del pedido no está disponible");
        }
    }

    async function entregar(row, value) {
        setCargando(true);
        let resp = await entregaPedido(row.pedido_id, value);
        setCargando(false);
        if (resp.error) {
            setError(resp.messages[0]);
            window.scrollTo(0,0);
        } else {
            alert("Pedido actualizado correctamente.");
            setCargando(true);
            buscar();
            setCargando(false);
        }
        //alert(`Se debe marcar la entrega del producto con id ${row.pedido_id} con valor: ${value}`);
    }

    const columnas = [
        {
            titulo:"Número",
            atributo:"numero",
            className:"text-truncate"
        },{
            titulo:"Fecha",
            atributo:"fecha"
        },{
            titulo:"Marca",
            atributo:"marca",
            className:"d-none d-md-table-cell text-truncate max-width-20-em"
        },{
            titulo:"Cliente",
            atributo:"cliente",
            className:"text-truncate max-width-20-em"
        },{
            titulo:"Total",
            atributo:"total",
            className:"col-importe",
            funcion: formatNumber
        },{
            titulo:"Comisión",
            atributo:"comision",
            className:"d-none d-md-table-cell col-importe",
            funcion: formatNumber
        }
    ]

    return <>
        <BreadcrumbPedidos active="Entrega de Pedidos"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Desde</InputGroup.Text>
                    <Form.Control
                        id="txtFechaDesde" 
                        type="date"
                        value={fechaDesde} onChange={(e) => {setFechaDesde(e.target.value)}}
                        placeholder="Fecha desde..."
                    />
                    </InputGroup>
                </Col>
                <Col xs="auto" md="1">
                </Col>
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Hasta</InputGroup.Text>
                    <Form.Control
                        id="txtFechaHasta" 
                        type="date"
                        value={fechaHasta} onChange={(e) => {setFechaHasta(e.target.value)}}
                        placeholder="Fecha hasta..."
                    />
                    </InputGroup>
                </Col>
                <Col xs="auto" md="4">
                </Col>
                <Col xs="auto" md="4">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Marca</InputGroup.Text>
                    <Form.Select 
                        id="selMarca" value={marca}
                        onChange={(e) => {setMarca(e.target.value);}}>
                        <option value="">Seleccione...</option>
                        {marcas.map((m) => <option key={m.marca_id} value={m.marca_id}>{m.nombre}</option>)}
                    </Form.Select>
                    </InputGroup>
                </Col>
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 6+'em'}}>Entregado</InputGroup.Text>
                    <Form.Select id="selEstado" 
                        value={estado} onChange={(e) => {setEstado(e.target.value)}}>
                        <option value="">Todos</option>
                        <option value="N">No</option>
                        <option value="S">Si</option>
                    </Form.Select>
                    </InputGroup>
                </Col>
                <Col xs="auto">
                    <InputGroup className="mb-2">
                    <Button id="btnBuscar" onClick={() => buscar()}>
                        Buscar
                    </Button>
                    </InputGroup>
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        {cargando?<Cargando></Cargando>:<></>}
        <MaoTable 
            columnas={columnas} 
            datos={pedidos} 
            colId="pedido_id"
            colEstado="entregado"
            colNombre="numero"
            valueEstadoInactivo="P"
            /*getEstado={(estado) => {return (estado==='F'?'Finalizado':'Pendiente')}}*/
            onDoubleClick={(row) => descargar(row.pedido_uuid)}
            tituloAcciones="Entregado"
            otrasAcciones={[
                {
                    control: function(row) {
                        return (
                            <div className="d-flex align-items-center">
                                <Form.Check 
                                    type="switch" 
                                    title="Entregar"
                                    checked={row.entregado === 'S'}
                                    onChange={(e) => { entregar(row, e.target.checked); }}
                                    className="me-2"
                                />
                                <Button 
                                    variant="primary" 
                                    size="sm"
                                    title="PDF de Pedido"
                                    onClick={() => descargar(row.pedido_uuid)}
                                >
                                    <FaFilePdf />
                                </Button>
                            </div>
                        );
                    }
                },
            ]}>
        </MaoTable>
    </>
        
}